import React from "react";
import moment from "moment";
import { Renderer, ResourceDescriptor } from "./common";
import DeleteResourceButton from "../components/DeleteResourceButton";
import { FormattedMessage } from "react-intl";

const commonRenderers: Record<string, Renderer> = {
    client(val, row) {
        // eslint-disable-next-line formatjs/enforce-default-message, formatjs/enforce-id
        return <FormattedMessage id={row.client.display_name} />;
    },
    expires_at(val, row) {
        return row.refresh_token_expires_in === 0 ? (
            <FormattedMessage id="never" defaultMessage="Never" />
        ) : (
            moment.unix(row.issued_at + row.expires_in).format("YYYY-MM-DD HH:mm:ss")
        );
    },
};

const token: ResourceDescriptor = {
    url: "token",
    orders: {
        list: ["client", "expires_at", "controlHeaderCell"],
        create: ["client"],
    },
    crudActions: ["create", "read", "delete", "list"],
    renderers: {
        delete: commonRenderers,
        list: {
            ...commonRenderers,
            controlHeaderCell(val, data) {
                return <DeleteResourceButton resourceName="token" id={data.id} />;
            },
        },
    },
    identifiers: ["client", "expires_at"],
};

export default token;
